import { ApplicationFlow } from '@square/dashboard-protos/models/squareup/sfs/external/models/application_flow';

type StatusToRoute = {
  [key in ApplicationFlow.Status]?: string;
};

export const ROUTE_FOR_STATUS: StatusToRoute = {
  [ApplicationFlow.Status.OPEN]: 'signup.two-factor',
  [ApplicationFlow.Status.AGREEMENTS_ACCEPTED]: 'signup.please-wait',
  [ApplicationFlow.Status.RESUBMITTED]: 'signup.please-wait',
  [ApplicationFlow.Status.IDV_COMPLETED]: 'signup.please-wait',
  [ApplicationFlow.Status.TIN_COMPLETED]: 'signup.please-wait',
  [ApplicationFlow.Status.BANK_CUSTOMER_CREATED]: 'signup.please-wait',
  [ApplicationFlow.Status.SUCCEEDED]: 'signup.account-open',
  [ApplicationFlow.Status.INELIGIBLE]: 'signup.ineligible',
  [ApplicationFlow.Status.ERRORED]: 'signup.errored',
  [ApplicationFlow.Status.IN_MANUAL_REVIEW]: 'signup.in-manual-review',
  [ApplicationFlow.Status.DOCUMENTS_REQUESTED]: 'signup.documents-requested',
};

export const ROUTE_FOR_TERMINAL_STATUS: StatusToRoute = {
  [ApplicationFlow.Status.SUCCEEDED]: 'signup.account-open',
  [ApplicationFlow.Status.INELIGIBLE]: 'signup.ineligible',
  [ApplicationFlow.Status.ERRORED]: 'signup.errored',
  [ApplicationFlow.Status.IN_MANUAL_REVIEW]: 'signup.in-manual-review',
  [ApplicationFlow.Status.DOCUMENTS_REQUESTED]: 'signup.documents-requested',
};

export const routeForStatusDuringPleaseWait = (
  status: ApplicationFlow.Status,
  doNotPrefill: boolean
) => {
  if (status === ApplicationFlow.Status.OPEN) {
    return doNotPrefill
      ? 'signup.enter-identity-info'
      : 'signup.confirm-identity';
  }

  // If the ERRORED status is encountered during the initial submit of the
  // application send the user to the timeout route to explain that we will
  // get back to them.
  if (status === ApplicationFlow.Status.ERRORED) {
    return 'signup.timeout';
  }
  return ROUTE_FOR_STATUS[status];
};
